import { ApiService } from '../api/ApiService';

const EVENT_CHECK_SUBTYPES: Record<string, string> = {
    'Advance Request': 'Request Advance',
    'LP Advance Request': 'LP Request Advance',
    'Passenger Submit': 'Passenger Form',
    'LP Passenger Submit': 'LP Passenger Form',
    'Yard Submit': 'Yard Check',
    'LP Yard Submit': 'LP Yard Check',
    'DM Info': 'Opend DM info',
    'LP DM Info': 'LP Opend DM info',
    'Motive Link': 'Motive url',
    'LP Motive Link': 'LP Motive url',
    'Infiniti Link': 'Infiniti url',
    'LP Infiniti Link': 'LP Infiniti url',
};

export function logUserAction(subtype: string, message: string) {
    ApiService.sendEventCommand(subtype, 'userAction', message);
    const eventCheckSubtype = EVENT_CHECK_SUBTYPES[subtype] ?? subtype;
    ApiService.sendEventCommand(eventCheckSubtype, 'eventCheck', message);
}
